import fetchJSONHandleError from 'utils/NET/fetchJSONHandleError'

export function getQuote(baseUrl: string, data: Record<string, unknown>) {
  return fetchJSONHandleError({ url: `${baseUrl}/v2/getQuote`, data })
}
